var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.458984,
    y: 0.601562,
    width: 26.4313,
    height: 26.4313,
    rx: 13.2156,
    fill: "#EBA4A6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13542_12824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27076 15.2505C8.10567 15.7645 7.38281 16.4807 7.38281 17.2729C7.38281 18.837 10.2004 20.1049 13.676 20.1049C17.1516 20.1049 19.9691 18.837 19.9691 17.2729C19.9691 16.4807 19.2463 15.7645 18.0812 15.2505M17.4519 11.2944C17.4519 13.8518 14.6199 15.0703 13.676 16.9583C12.732 15.0703 9.90007 13.8518 9.90007 11.2944C9.90007 9.20908 11.5906 7.51855 13.676 7.51855C15.7613 7.51855 17.4519 9.20908 17.4519 11.2944ZM14.3053 11.2944C14.3053 11.642 14.0235 11.9238 13.676 11.9238C13.3284 11.9238 13.0467 11.642 13.0467 11.2944C13.0467 10.9469 13.3284 10.6651 13.676 10.6651C14.0235 10.6651 14.3053 10.9469 14.3053 11.2944Z",
    stroke: "#CE2126",
    strokeWidth: 1.25863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13542_12824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1036,
    height: 15.1036,
    fill: "white",
    transform: "translate(6.125 6.25977)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.6e2ceaf131e969b5211d3d6b17119ec7.svg";
export { ForwardRef as ReactComponent };